import React from "react";
import fieldPropTypes from "./field-prop-types";

/* eslint-disable react/jsx-key */
const buildheaderDetails = ({
  field: {
    data: { header_details }
  },
  components: { Text, Label, FieldWrapper }
}) =>
  header_details.map(headerDetail => (
    <FieldWrapper>
      <FieldWrapper>
        <Label text={headerDetail?.title} />
      </FieldWrapper>
      <Text label={headerDetail?.value} />
    </FieldWrapper>
  ));

const MessageHeaderView = ({ field, components }) => (
  <components.MessageHeader
    data={field.data}
    headerDetails={buildheaderDetails({ field, components })}
  />
);

MessageHeaderView.propTypes = fieldPropTypes;

export default MessageHeaderView;
